export const collections = {
  allUser: 'ALL-user',
  allOptions: 'ALL-options',
  allMail: 'ALL-mail',
  allPosts: 'ALL-posts',
};
